/** @jsxImportSource @emotion/react */
import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import { jsx, css, keyframes } from "@emotion/react";
import pr from "../lib/pr";
import {
  Grid,
  Box,
  TextField,
  Badge,
  Typography,
  Dialog,
  Button,
  Paper,
  Divider,
  SwipeableDrawer,
  Snackbar,
  Alert,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import styled from "@emotion/styled";
import add_comma from "../lib/add_comma";
import queryString from "query-string";
import get_token from "../lib/get_token";
import { loginState, configState } from "../lib/State";
import axios from "axios";
import Swal from "sweetalert2";
import Chip from "@mui/material/Chip";
import HelpCouponCode from "./HelpCouponCode";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import get_cid from "../lib/get_cid";
import send_webview_data from "../lib/send_webview_data";

// 쿠폰 안 받았을 때
const noCoupon = css`
  width: 80%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: white;
  border-radius: 10px;
  height: 120px;
  margin-bottom: 30px;
  padding: 10px;
`;

// 쿠폰 받았을 때
const yesCoupon = css`
  width: 80%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: white;
  border-radius: 10px;
  height: 150px;
  margin-bottom: 30px;
  padding: 10px;
`;

// 부모창에서 자식함수 호출할때 (자식창에있는 대화상자 오픈)

// 깜빡이는 텍스트
const blinkEffect = keyframes`
  50% {
    opacity: 0;
  }
`;

// 바 컬러
const heartBarNoColor = css`
  width: 1px;
  height: 50px;
  padding: 0;
  margin: 0;
  background: white;
`;
const heartBarColor = css`
  width: 3px;
  height: 50px;
  padding: 0;
  margin: 0;
  background: white;
  border-left: 1px solid #00ffff;
  border-right: 1px solid #00ffff;
`;

//바 서클 컬러
const heartCircleNoColor = css`
  width: 18px;
  height: 18px;
  border: 1.5px solid white;
  border-radius: 100%;
`;
const heartCircleColor = css`
  width: 18px;
  height: 18px;
  color: white;
  background: white;
  border: 1.5px solid #00ffff;
  border-radius: 100%;
`;

//박스 테두리 빛
const heartBoxColor = css`
  box-shadow: 2px 2px 5px 1px #00ffff, -2px -2px 5px 1px #00ffff;
`;

// 스코롤 박스
const ScrollBox = styled(Box)`
  height: 100px;
`;

// 포인트 작은쪽
const SmallPoint = styled(Box)`
  position: relative;
  .point {
    position: absolute;
    color: white;
    margin-top: 63px;
    margin-left: 56px;
  }
  .typo {
    font-weight: bold;
    font-size: 12px;
  }
`;

const LargePoint = styled(Box)`
  margin-top: -10px;
  position: absolute;
  margin-left: 25px;
  .point {
    position: absolute;
    margin-top: 95px;
    margin-left: 70px;
    width: 50px;
    text-align: right;
  }
  .text {
    font-size: 14px;
    color: white;
  }
`;

// 비활성 버튼
const MyButton = styled(Button)`
  &&& {
    &.Mui-disabled {
      color: white;
      /* background: #bbc3f4; */
      background: darkgray;
    }
  }
`;

const mallButton = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        startIcon: {
          padding: 0,
          margin: 0,
          width: "50%",
        },
      },
    },
  },
});

const HomeClassPoint = forwardRef((props, ref) => {
  const { login } = props;
  let { flag } = queryString.parse(window.location.search);
  flag = flag !== undefined ? true : false;
  const [open, setOpen] = useState(flag);
  const [cid, setCid] = useState(get_cid());

  useImperativeHandle(ref, () => ({
    open() {
      setOpen(true);
      load_data();
    },
  }));

  const [clicked, setClicked] = useState(false);
  const [rows, setRows] = useState([]);
  const token = get_token();
  const [total_point, setTotalPoint] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [bonus, setBonus] = useState([]);
  const [reqitem, setReqItem] = useState([]);
  const [copied, setCopied] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);

  // 복사 팝업 닫기
  const closeSnack = (e, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  // 보너스 초기화
  const load_bonus = async () => {
    setBonus([
      {
        count: 20,
        img: "/img/fre_goods30.jpg",
        title1: (
          <Box sx={{ display: "flex" }}>
            20회 보상
            <Box sx={{ textDecoration: "line-through" }}>(30회 보상)</Box>
          </Box>
        ),
        title2: "두써킷 티셔츠",
      },
      {
        count: 40,
        img: "/img/fre_goods40.jpg",
        title1: "40회 보상",
        title2: "스포츠 타월 + 5% 할인권",
      },

      {
        count: 50,
        img: "/img/fre_goods50.jpg",
        title1: "50회 보상",
        title2: "스포츠 파우치",
      },

      {
        count: 60,
        img: "/img/fre_goods60.jpg",
        title1: "60회 보상",
        title2: "스포츠 텀블러 + 10% 할인권",
      },
      {
        count: 80,
        img: "/img/fre_goods80.jpg",
        title1: "80회 보상",
        title2: "옐로 손목 보호대  + 10% 할인권 (6개월)",
      },

      {
        count: 140,
        img: "/img/fre_goods140.jpg",
        title1: "140회 보상",
        title2: "화이트 손목 보호대 + 10% 할인권 (6개월)",
      },

      {
        count: 200,
        img: "/img/fre_goods200.jpg",
        title1: "200회 보상",
        title2: "블루 손목 보호대 + 10% 할인권 (6개월)",
      },
      {
        count: 260,
        img: "/img/fre_goods260.jpg",
        title1: "260회 보상",
        title2: "레드 손목 보호대 + 10% 할인권 (6개월)",
      },
      {
        count: 320,
        img: "/img/fre_goods320.jpg",
        title1: "320회 보상",
        title2: "블랙 손목 보호대 + 10% 할인권 (6개월)",
      },
    ]);
  };
  useEffect(() => {
    load_bonus();
  }, []);

  // 보너스구간 이미지
  // let cash = {
  //   20: [{
  //     current: "/img/goods1_current.jpg",
  //     previous: "/img/goods1_current.jpg",
  //     next: "/img/goods1_prev.jpg",
  //   }],
  //   30: [
  //     {
  //       current: '/img/goods2_coupon_current.jpg',
  //       previous: '/img/goods2_coupon_done.jpg',
  //       next: '/img/goods2_coupon_prev.jpg',
  //     },
  //     {
  //       current: '/img/goods2_current.jpg',
  //       previous: '/img/goods2_done.jpg',
  //       next: '/img/goods2_prev.jpg',
  //     }
  //   ],
  //   40: [
  //     {
  //       current: '/img/goods3_current.jpg',
  //       previous: '/img/goods3_done.jpg',
  //       next: '/img/goods3_prev.jpg',
  //     },
  //   ],
  //   50: [
  //     {
  //       current: '/img/goods4_coupon_current.jpg',
  //       previous: '/img/good4s_coupon_done.jpg',
  //       next: '/img/goods4_coupon_prev.jpg',
  //     },
  //     {
  //       current: '/img/goods4_current.jpg',
  //       previous: '/img/goods4_done.jpg',
  //       next: '/img/goods4_prev.jpg',
  //     }
  //   ],
  //   60: [
  //     {
  //       current: '/img/goods5_current.jpg',
  //       previous: '/img/goods5_done.jpg',
  //       next: '/img/goods5_prev.jpg',
  //     },
  //   ],
  // }

  // 캐시 적립과정
  // 적립될 캐시가 우선은 point에 기록되어 있고
  // 실제 amount 값은 수령 후에 처리됨

  // 회원정보 (DB)
  // p100 : 왼쪽라인
  // p500 : 오른쪽라인
  // undefined (아직)/ >0 안빋음 / 0 받음
  // const [p100, setP100] = useState({});
  // const [p500, setP500] = useState({});

  // TEST
  // let p100 = {
  //   1:1,
  // }
  // let p500 = {
  // }
  // 캐시 이미지 등록
  // const img = {
  //   sm: {
  //     current: "/img/coin_current_no.jpg",
  //     previous: "/img/checkin_done.jpg", //과거도장
  //     next: "/img/checkin_prev.jpg", //미래도장
  //   },
  //   lg: {
  //     current: "/img/coin_plus_current_no.jpg",
  //     previous: "/img/coin_plus_done_no.jpg",
  //     next: "/img/coin_plus_prev_no.jpg",
  //   },
  //   progress: {
  //     current: "/img/point_progress_now.png",
  //     previous: "/img/point_progress_previous.png",
  //     next: "/img/point_progress_next.png",
  //   },
  // };
  // let temp = [];
  // for (let i = 0; i < 70; i++) {
  //   temp.push({
  //     point: 1,
  //     point_idx: (i + 1) * 1,
  //     bonus: 0,
  //     sm_img: img.sm.next,
  //     lg_img: img.lg.next,
  //     progress: img.progress.next,
  //     sm_active: false,
  //     lg_active: false,
  //   });
  // }
  // useEffect(() => {
  //   setRows(temp);
  // }, []);

  const closeClick = () => {
    setOpen(false);
  };

  const load_data = async () => {
    // 신청현황 로드
    await load_state();

    let result;
    const postData = {
      token: token,
      cid: cid,
      mcd: login.mcd,
      level: login.level,
      type: "출석포인트",
    };

    // 카운트
    result = await axios.post(
      configState.api + "/gympass/home_count_frequency",
      postData
    );
    setTotalPoint(result.data.count);
  };

  // 사은품 요청
  const req_item = async (idx) => {
    const postData = {
      token: token,
      cid: cid,
      mcd: login.mcd,
      level: login.level,
      idx: idx,
    };
    let result = await axios.post(
      configState.api + "/gympass/home_item_request",
      postData
    );
    if (result.data.success !== 1) {
      Swal.fire("Error", result.data.msg);
      return;
    } else {
      Swal.fire(
        "쿠폰 발급 완료",
        "쿠폰 발급이 완료되었습니다. 스마트몰에서 사은품을 신청하세요."
      );

      await load_state();
    }
  };

  // 상품 신청상태
  const load_state = async () => {
    const postData = {
      token: token,
      cid: cid,
      mcd: login.mcd,
      level: login.level,
      type: "출석포인트",
    };
    let result = await axios.post(
      configState.api + "/gympass/home_item_state",
      postData
    );
    setReqItem(result.data.rows);
  };

  // 스마트몰 바로가기
  const go_mall = () => {
    send_webview_data({
      id: "open_url",
      value: "https://smartmall.kr",
      cid: cid,
    });
    // Swal.fire('스마트몰 쇼핑몰 안내', `smartmall.kr 에 접속해서 <br/> 프리퀀시 사은품을 신청하세요.`)
  };

  return (
    <>
      <Dialog fullScreen open={open} onClose={closeClick}>
        <Box
          sx={{
            height: "100%",
            backgroundImage: `url(/img/point_class_bg_full.jpg)`,
            backgroundRepeat: "repeat-y",
            backgroundSize: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* 상단 */}
          <Box
            sx={{
              marginBottom: "2rem",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box onClick={closeClick}>
                <img
                  src="/img/back_button.png"
                  style={{ height: "30px", margin: "35px 8px" }}
                />
              </Box>
              {/* <Button
                variant="contained"
                onClick={go_mall}
                sx={{
                  // background: '#94b5a5',
                  background: '#f80070',
                  fontWeight: 'bold',
                  marginRight: '18px'
                }}>
                  스마트몰 바로가기
              </Button> */}
            </Box>
            <Box sx={{ height: 70, textAlign: "center", top: 10 }}>
              <Box
                sx={{
                  color: "white",
                  fontSize: "46px",
                  fontFamily: "BebasNeue",
                }}
              >
                DOCIRCUIT FREQUENCY
              </Box>
              <Box
                sx={{
                  mt: -1,
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "18px",
                }}
              >
                출석 프리퀀시
              </Box>
            </Box>

            <Box className="m-auto text-center">
              <ThemeProvider theme={mallButton}>
                <Button
                  variant="contained"
                  onClick={go_mall}
                  sx={{
                    width: "80%",
                    background: "black",
                    border: "1px solid darkgray",
                    fontWeight: "bold",
                    marginTop: 4,
                    padding: "10px 6px",
                    borderRadius: "10px",
                  }}
                  startIcon={
                    <img
                      src="/img/smartmall_logo.png"
                      style={{ width: "80%" }}
                    />
                  }
                >
                  쇼핑몰 바로가기
                </Button>
              </ThemeProvider>
            </Box>

            {/* 누적포인트 */}
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <Box
                sx={{
                  background: "white",
                  zIndex: 5,
                  width: "80%",
                  height: "40px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "25px 15px",
                  borderRadius: "10px",
                }}
              >
                <Box
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  출석 프리퀀시
                </Box>
                <Box
                  sx={{
                    fontSize: "22px",

                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      ml: 0.3,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      fontFamily="BebasNeue"
                      sx={{ fontSize: 22, color: "#0092a2" }}
                    >
                      {add_comma(total_point)}
                    </Typography>
                    <Typography
                      sx={{ ml: 0.1, fontSize: 16, fontWeight: "bold" }}
                    >
                      회
                    </Typography>
                  </Box>

                  {/* <Button variant="contained" onClick={increasePt}>+100</Button> */}
                </Box>
              </Box>
            </Box>
          </Box>

          {/* 하단 */}
          <Box sx={{ flex: 1, overflow: "scroll" }}>
            <Box sx={{ mt: 1.5 }}>
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-around",
                    // marginBottom: '20px',
                    // width: '80%'
                  }}
                >
                  <Box>
                    {bonus.map((item, index) => {
                      let img = item.img;
                      let title1 = item.title1;
                      let title2 = item.title2;
                      let idx = -1;
                      let state = "";
                      let opt = "";
                      idx = reqitem.findIndex((el) => el.count === item.count);
                      if (idx > -1) {
                        state = reqitem[idx].state;
                        opt = reqitem[idx].opt + "";
                      }
                      return (
                        <Box
                          key={index}
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {(total_point >= item.count && state === "") ||
                          total_point < item.count ? (
                            // 쿠폰 안 받은 경우
                            <Box
                              sx={{
                                width: "80%",
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                background: "white",
                                borderRadius: "10px",
                                height: "120px",
                                marginBottom: "30px",
                                padding: "10px",
                              }}
                            >
                              <Box
                                sx={{
                                  color: "white",
                                  width: "155px",
                                  textAlign: "center",
                                  flex: 1,
                                }}
                              >
                                <img src={img} />
                              </Box>
                              <Box
                                sx={{
                                  width: "60%",
                                  marginLeft: "5px",
                                }}
                              >
                                <Box
                                  sx={{
                                    color: "black",
                                    fontSize: "13px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {title1}
                                </Box>
                                <Box
                                  sx={{
                                    color: "black",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {title2}
                                </Box>

                                {total_point >= item.count && state === "" && (
                                  <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                      marginTop: "10px",
                                      width: "100px",
                                      background: "#f80070",
                                      boxShadow: "none",
                                      fontWeight: "bold",
                                    }}
                                    onClick={(e) => req_item(item.count)}
                                  >
                                    쿠폰 받기
                                  </Button>
                                )}

                                {total_point >= item.count &&
                                  state === "신청" && (
                                    <Box sx={{ mt: 1 }}>
                                      <Chip color="default" label="신청완료" />
                                    </Box>
                                  )}

                                {total_point >= item.count &&
                                  state === "발송" && (
                                    <Box sx={{ mt: 1 }}>
                                      <Chip color="default" label="발송완료" />
                                    </Box>
                                  )}

                                {total_point >= item.count &&
                                  state === "취소" && (
                                    <Box sx={{ mt: 1 }}>
                                      <Chip color="default" label="취소완료" />
                                    </Box>
                                  )}

                                {total_point < item.count && (
                                  <MyButton
                                    disabled
                                    color="error"
                                    variant="contained"
                                    size="small"
                                    sx={{
                                      marginTop: "10px",
                                      width: "100px",
                                    }}
                                  >
                                    쿠폰 받기
                                  </MyButton>
                                )}
                              </Box>
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                width: "80%",
                                background: "white",
                                borderRadius: "10px",
                                /* height: "145px", */
                                marginBottom: "30px",
                                padding: "10px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                              }}
                            >
                              <Box
                                sx={{
                                  // width: '80%',
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  background: "white",
                                  // borderRadius: '10px',
                                  // height: '150px',
                                  // marginBottom: '30px',
                                  // padding: '10px',
                                }}
                              >
                                <Box
                                  sx={{
                                    color: "white",
                                    width: "155px",
                                    textAlign: "center",
                                    flex: 1,
                                  }}
                                >
                                  <img src={img} />
                                </Box>
                                <Box
                                  sx={{
                                    width: "60%",
                                    marginLeft: "5px",
                                  }}
                                >
                                  {/* {item.count === 20 ? 
                                // <Box
                                //   sx={{
                                //     background: '#0092a2',
                                //     width: 'fit-content'
                                //   }}>
                                <Box
                                sx={{
                                  animation: `${blinkEffect} 1.5s ease-in-out 0.5s infinite`,
                                  background: '#0092a2',
                                  // background: 'orange',
                                  color: 'white',
                                  width: 'fit-content',
                                  fontSize: '13px',
                                  fontWeight: 'bold',
                                  padding: '3px 5px',
                                  // marginBottom: '5px',
                                }}>
                                Event
                              </Box>
                              // </Box>
                              : null
                              } */}

                                  <Box
                                    sx={{
                                      color: "black",
                                      fontSize: "13px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {title1}
                                  </Box>
                                  <Box
                                    sx={{
                                      color: "black",
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {title2}
                                  </Box>

                                  {state === "발급" && (
                                    <>
                                      {/* <Button
                                          variant='contained'
                                          sx={{
                                            marginTop: "5px",
                                            fontSize: '13px',
                                            background: '#94b4a5',
                                            boxShadow: 'none',
                                            padding: '4px 10px',
                                            ':hover': { background: '#94b4a5', }
                                          }}
                                          onClick={() => window.open('https://www.smartmall.kr/', '_blank')}
                                        >
                                          스마트몰 바로가기
                                        </Button> */}
                                      <Box
                                        sx={{
                                          marginTop: "5px",
                                        }}
                                      >
                                        <HelpCouponCode />
                                        <Box
                                          sx={{
                                            fontWeight: "bold",
                                            fontSize: "13px",
                                            letterSpacing: "1.5px",
                                            width: "fit-content",
                                            background: "#e4e4e4",
                                            padding: "5px 12px",
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <CopyToClipboard
                                            onCopy={() => setOpenSnack(true)}
                                            text={opt}
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                              }}
                                            >
                                              {opt}
                                              <ContentCopyIcon
                                                sx={{ fontSize: "14px" }}
                                              />
                                            </Box>
                                          </CopyToClipboard>
                                        </Box>
                                        <p className="text-xs mt-1 opacity-70 tracking-tighter">
                                          사용기간 : 발급일로부터 90일 이내
                                        </p>
                                      </Box>
                                    </>
                                  )}

                                  {/* {total_point >= item.count && state === "신청" && (
                                <Box sx={{mt:1}}><Chip color="default" label="신청완료"/></Box>
                              )}

                              {total_point >= item.count && state === "발송" && (
                                <Box sx={{mt:1}}><Chip color="default" label="발송완료"/></Box>
                              )} */}

                                  {total_point >= item.count &&
                                    state === "취소" && (
                                      <Box sx={{ mt: 1 }}>
                                        <Chip
                                          color="default"
                                          label="취소완료"
                                        />
                                      </Box>
                                    )}
                                </Box>
                              </Box>
                              {/* {state === '발급' && (
                                <Box
                                  sx={{
                                    display: 'flex',
                                  }}>
                                  <Box width='155px'></Box>
                                  <Box
                                    sx={{
                                      fontWeight: 'bold',
                                      fontSize: '12px',
                                      letterSpacing: '1.5px',
                                      // background: '#e4e4e4',
                                      width: 'fit-content',
                                      // padding: '5px 12px',
                                      // marginTop: '3px',
                                      marginLeft: '5px'
                                    }}
                                    onClick={() => copyAction()}
                                  >
                                    <HelpCouponCode />
                                    <CopyToClipboard text={opt} onCopy={() => setCopied(true)} >
                                      <Box>{opt}</Box>
                                    </CopyToClipboard>
                                  </Box>
                                </Box>
                              )} */}
                            </Box>
                          )}
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Snackbar open={openSnack} autoHideDuration={1000} onClose={closeSnack}>
          <Alert onClose={closeSnack} width="100%">
            복사 되었습니다
          </Alert>
        </Snackbar>
      </Dialog>
    </>
  );
});

export default HomeClassPoint;

// {rows.map((item, index) => {
//   const idx = item.point_idx;

//   // const tmp_cash = cash[idx] !== undefined ? cash[idx] : 0; // 보너스 캐시
//   // let tmp_cash = 0;
//   // const point = item.point; // 100, 100, 100 ...
//   // 100캐시 받기처리 (-1/100/0)
//   // const tmp_p100 = p100[idx] !== undefined ? p100[idx] : -1;
//   // 500캐시, 5000캐시 받기처리
//   // const tmp_p500 = p500[idx] !== undefined ? p500[idx] : -1;

//   // 바 이미지
//   let bar_image =
//     total_point === item.point_idx
//       ? img.progress.current
//       : total_point > idx
//         ? img.progress.previous
//         : img.progress.next;

//   // 좌측출석 -1/0/1 (다음/안받음/받음)
//   let tmp_p100 = 0;
//   if (p100[idx] !== undefined) {
//     if (p100[idx] === 1) tmp_p100 = 1;
//   }

//   // 우측
//   // 0 , 1
//   let tmp_p500 = 0;
//   let tmp_p500_show = false;
//   if (cash[idx] !== undefined) {
//     tmp_p500_show = true;
//   }

//   return (
//     <Box key={index} sx={{ display: "flex" }}>

//       {/* 좌측_포인트 */}
//       <Box sx={{ width: 110 }}>
//         {tmp_p100 === 0 && <img src={img.sm.next} />}
//         {tmp_p100 === 1 && <img src={img.sm.previous} />}
//       </Box>

//       {/* 중간바 */}
//       <Box
//         sx={{
//           width: 30,
//           height: "100px",
//           backgroundImage: `url(${bar_image})`,
//           backgroundPosition: "center center",
//           backgroundRepeat: "no-repeat",
//         }}
//       >
//         <a name={"p" + idx}></a>
//       </Box>

//       {/* 우측포인트 */}
//       <Box sx={{ width: 110 }}>
//         <Box sx={{ position: "relative" }}>
//           <LargePoint>
//             {tmp_p500_show && (
//               <>
//                 {cash[idx].map((item1, index1) => {
//                   return <Box key={index1}>
//                     {p500[idx] === undefined && <img src={item1.next} />}
//                     {p500[idx] === 0 && <img src={item1.current} />}
//                     {p500[idx] === 1 && <img src={item1.previous} />}
//                   </Box>
//                 })}
//               </>
//             )}
//           </LargePoint>
//         </Box>
//       </Box>
//     </Box>
//   );
// })}

// {/* 20회 */}
// <Box
// sx={{
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   padding: "20px",
// }}
// >
// <img src="/img/goods1_prev.jpg" />
// <Box
//   sx={{
//     width: "60%",
//   }}
// >
//   <Box
//     sx={{
//       color: "white",
//       fontSize: "14px",
//     }}
//   >
//     20회 보상
//   </Box>
//   <Box
//     sx={{
//       color: "white",
//       fontWeight: "bold",
//     }}
//   >
//     두써킷 티셔츠
//   </Box>
//   <Button
//     variant="contained"
//     sx={{
//       marginTop: "10px",
//       width: "120px",
//     }}
//   >
//     사은품 신청
//   </Button>
// </Box>
// </Box>

// {/* 40회 */}
// <Box
// sx={{
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   padding: "20px",
// }}
// >
// <img src="/img/goods3_prev.jpg" />
// <Box
//   sx={{
//     width: "60%",
//   }}
// >
//   <Box
//     sx={{
//       color: "white",
//       fontSize: "14px",
//     }}
//   >
//     40회 보상
//   </Box>
//   <Box
//     sx={{
//       color: "white",
//       fontWeight: "bold",
//     }}
//   >
//     스포츠 파우치
//   </Box>
//   <Button
//     variant="contained"
//     sx={{
//       marginTop: "10px",
//       width: "120px",
//     }}
//   >
//     사은품 신청
//   </Button>
// </Box>
// </Box>

// {/* 50회 */}
// <Box
// sx={{
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   padding: "20px",
// }}
// >
// <Box>
//   {/* <img src='/img/goods2_prev.jpg' />
//     <img src='/img/goods2_coupon_prev.jpg' /> */}
//   <img src="/img/goods50.jpg" />
// </Box>
// <Box
//   sx={{
//     width: "60%",
//   }}
// >
//   <Box
//     sx={{
//       color: "white",
//       fontSize: "14px",
//     }}
//   >
//     50회 보상
//   </Box>
//   <Box
//     sx={{
//       color: "white",
//       fontWeight: "bold",
//     }}
//   >
//     스포츠 텀블러 &amp; 10% 할인권
//   </Box>
//   <Button
//     variant="contained"
//     sx={{
//       marginTop: "10px",
//       width: "120px",
//     }}
//   >
//     사은품 신청
//   </Button>
// </Box>
// </Box>

// {/* 60회 */}
// <Box
// sx={{
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   padding: "20px",
// }}
// >
// <img src="/img/goods5_prev.jpg" />
// <Box
//   sx={{
//     width: "60%",
//   }}
// >
//   <Box
//     sx={{
//       color: "white",
//       fontSize: "14px",
//     }}
//   >
//     60회 보상
//   </Box>
//   <Box
//     sx={{
//       color: "white",
//       fontWeight: "bold",
//     }}
//   >
//     옐로 손목 보호대
//   </Box>
//   <Button
//     variant="contained"
//     sx={{
//       marginTop: "10px",
//       width: "120px",
//     }}
//   >
//     사은품 신청
//   </Button>
// </Box>
// </Box>

// {/* 120회 */}
// <Box
// sx={{
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   padding: "20px",
// }}
// >
// <img src="/img/goods5_prev.jpg" />
// <Box
//   sx={{
//     width: "60%",
//   }}
// >
//   <Box
//     sx={{
//       color: "white",
//       fontSize: "14px",
//     }}
//   >
//     120회 보상
//   </Box>
//   <Box
//     sx={{
//       color: "white",
//       fontWeight: "bold",
//     }}
//   >
//     그린 손목 보호대
//   </Box>
//   <Button
//     variant="contained"
//     sx={{
//       marginTop: "10px",
//       width: "120px",
//     }}
//   >
//     사은품 신청
//   </Button>
// </Box>
// </Box>

// {/* 180회 */}
// <Box
// sx={{
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   padding: "20px",
// }}
// >
// <img src="/img/goods5_prev.jpg" />
// <Box
//   sx={{
//     width: "60%",
//   }}
// >
//   <Box
//     sx={{
//       color: "white",
//       fontSize: "14px",
//     }}
//   >
//     180회 보상
//   </Box>
//   <Box
//     sx={{
//       color: "white",
//       fontWeight: "bold",
//     }}
//   >
//     블루 손목 보호대
//   </Box>
//   <Button
//     variant="contained"
//     sx={{
//       marginTop: "10px",
//       width: "120px",
//     }}
//   >
//     사은품 신청
//   </Button>
// </Box>
// </Box>

// {/* 240회 */}
// <Box
// sx={{
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   padding: "20px",
// }}
// >
// <img src="/img/goods5_prev.jpg" />
// <Box
//   sx={{
//     width: "60%",
//   }}
// >
//   <Box
//     sx={{
//       color: "white",
//       fontSize: "14px",
//     }}
//   >
//     240회 보상
//   </Box>
//   <Box
//     sx={{
//       color: "white",
//       fontWeight: "bold",
//     }}
//   >
//     레드 손목 보호대
//   </Box>
//   <Button
//     variant="contained"
//     sx={{
//       marginTop: "10px",
//       width: "120px",
//     }}
//   >
//     사은품 신청
//   </Button>
// </Box>
// </Box>
//  {/* 300회 */}
//  <Box
//  sx={{
//    display: "flex",
//    justifyContent: "space-between",
//    alignItems: "center",
//    padding: "20px",
//  }}
// >
//  <img src="/img/goods5_prev.jpg" />
//  <Box
//    sx={{
//      width: "60%",
//    }}
//  >
//    <Box
//      sx={{
//        color: "white",
//        fontSize: "14px",
//      }}
//    >
//      300회 보상
//    </Box>
//    <Box
//      sx={{
//        color: "white",
//        fontWeight: "bold",
//      }}
//    >
//      블랙 손목 보호대
//    </Box>
//    <Button
//      variant="contained"
//      sx={{
//        marginTop: "10px",
//        width: "120px",
//      }}
//    >
//      사은품 신청
//    </Button>
//  </Box>
// </Box>
